// src/pages/Roadmap/StepVideo.jsx
// STATUS: active | UPDATED: 2026-10-19
// LOG:
//   2026-10-19  New. Plays the demonstration clip for one section of a step,
//               from src/content/stepVideos.js, and renders nothing when the
//               step has none yet.
// The clip sits at the top of its tab, above the reading, because a
// salesperson who has watched it done right reads the rest differently. The
// title under it says what is being shown and nothing more.

import { Box, Text } from '@chakra-ui/react'
import { videoFor, embedUrl } from '../../content/stepVideos'

export default function StepVideo({ slug, section }) {
  const clip = videoFor(slug, section)
  const src = embedUrl(clip)
  if (!src) return null
  return (
    <Box bg="card" border="1px solid" borderColor="line" borderRadius="card" overflow="hidden">
      <Box position="relative" pt="56.25%">
        <Box
          as="iframe"
          src={src}
          title={clip.title}
          allow="fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          border={0}
        />
      </Box>
      <Text px={5} py={3} fontSize="mono-xs" fontFamily="mono" textTransform="uppercase" letterSpacing="0.08em" color="inkDim">
        {clip.title}
      </Text>
    </Box>
  )
}
